// @ts-nocheck
const params = {
    currentCell: '',//当前单元格
    columns: [],//表格所有列
    data: [],//数据集合
    callback: null,//回调
    affected: [],//受影响的字段
    row: {},
    isRowIndex: false
}
/**
 * paste 事件
 * @param {*} e 
 */
export function getClipboardText (e) {
    let userAgent = navigator.userAgent;
    if (userAgent.indexOf("Chrome") > -1) {
        if (e.clipboardData) {
            for (let i in e.clipboardData.items) {
                let c = e.clipboardData.items[i]
                if (c.kind === "string" && c.type === "text/plain") {
                    c.getAsString(function(s) {
                        readClipboardData(s)
                    })
                }
            }
        }
    } else {
        readClipboardData(window.clipboardData.getData('Text'))
    }
    // e.preventDefault()
    // e.stopPropagation()
    // return false
}
/**
 * 生成数据
 * @param {*} s 粘贴板中的字符串
 */
export function readClipboardData (s) {
    let arry = (s.split("\r\n"))
    if (!arry) {
        return false
    }
    if (!arry[arry.length - 1]) {
        arry.pop()
    }
    params.affected = []
    arry.forEach((e, i) => {
        let data = e.split(/\t/)
        let obj = createdRows(data, i)
        let clone = cloneData(params.data[0])
        delete clone.index
        // params.data[i] ? Object.assign(params.data[i], obj) : params.data.push(Object.assign(clone, obj))
        if (params.data[i]) {
            let oldData = Object.assign({}, params.data[i], obj)
            delete oldData.index
            params.data[i] =  oldData
        } else {
            let data = Object.assign({}, clone, obj)
            params.data.push(data)
        }
        
    })
    if (typeof params.callback === 'function') {
        
        params.callback(params.isRowIndex, params.affected)
        
    }
}
export function getIndex () {
    let index = 0
    params.data.forEach((e, i) => {
        if (e.id == params.row.id) {
            return index = i
        }
    })
    return index
}
export function cloneData (data) {
    let newData = JSON.parse(JSON.stringify(data))
    for (let obj in newData) {
       if (newData[obj] && obj != 'index') {
        newData[obj] = ''
       }
    }
    return newData
}
/**
 * 生成对应的row 
 * @param {*} data 粘贴板中抽取的数据集合
 */
export function createdRows (data) {
    let switching = false
    let obj = {}
    params.columns.forEach(e => {
        if (e.property === params.currentCell) {
            switching = true
        }
        if (switching && data.length > 0) {
            if (e.type === 'filter') { //select 类型字段属于键值对 不能处理  请在列上加 type= select 过滤 <el-table-column type="select" 
                return false
            }
            let value = data.shift()
            obj[e.property] = value.trim()
        }
    })
    params.affected.push(obj)
    return obj
}
/**
 * paste 粘贴创建row 
 * @param {*} row 当前行
 * @param {*} column 当前列
 * @param {*} event dom对象
 * @param {*} tabls tabls指定的ref
 * @param {*} data 数据对象
 * @param {*} fn 回调
 * @param {@} isRowIndex 是否开启全表粘贴。默认只允许在第一行可以粘贴
 */
export function clipboard (row, column, event, tabls, data, fn, isRowIndex = false) {
    params.currentCell = column.property
    params.columns = tabls.getColumns()
    params.data = []
    params.row = row
    params.isRowIndex = isRowIndex
    data.forEach(e => {
        params.data.push(e)
    })
    params.callback = fn
    params.affected = []
    let obj = event.currentTarget
    obj.removeEventListener('paste', getClipboardText)
    obj.addEventListener('paste', getClipboardText)
}


export default clipboard